var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 1,
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#fff",
    stroke: "#D4366A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.27 14.448h-2.399l-.378-8.745h3.155l-.377 8.745zm-2.865 2.725c0-.434.155-.788.466-1.064.316-.28.71-.422 1.178-.422.469 0 .858.141 1.169.422.316.276.474.63.474 1.064 0 .433-.158.79-.474 1.072-.31.275-.7.413-1.17.413-.468 0-.86-.138-1.177-.413a1.383 1.383 0 01-.466-1.072z",
    fill: "#D4366A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.bfa947d2aa9de5db2782fef2ea81ae06.svg";
export { ForwardRef as ReactComponent };